import React from 'react';
import PropTypes from 'prop-types';

import AddressIcon from '@material-ui/icons/Business';
import EmailIcon from '@material-ui/icons/Email';
import LinkIcon from '@material-ui/icons/Link';
import PhoneIcon from '@material-ui/icons/Phone';

import Icon from '@components/Icon/Icon';
import Link from '@components/Link/Link';

import './DetailsCard.scss';

const DetailsCard = ({
  address,
  children,
  link,
  subtitle,
  title,
}) => (
  <div className="details-card">
    {title && (
      <div className="details-card__title">
        {title}
      </div>
    )}
    {subtitle && (
      <div className="details-card__subtitle">
        {subtitle}
      </div>
    )}
    {address && (
      <div className="details-card__content-wrapper">
        <div className="details-card__content">
          <div className="details-card__icon-text details-card__icon-text--align-top">
            <Icon className="details-card__icon-container">
              <AddressIcon />
            </Icon>
            <div>
              <p className="details-card__paragraph">
                {address.name}
              </p>
              <p className="details-card__paragraph">
                {address.street}
              </p>
              <p className="details-card__paragraph">
                {address.city}
              </p>
              <p className="details-card__paragraph">
                {address.state} {address.postalcode}
              </p>
              <p className="details-card__paragraph">
                {address.country}
              </p>
            </div>
          </div>
        </div>
        <div className="details-card__content">
          <div className="details-card__icon-text">
            <Icon className="details-card__icon-container">
              <PhoneIcon />
            </Icon>
            <div>
              {address.phone}
            </div>
          </div>
          <div className="details-card__icon-text">
            <Icon className="details-card__icon-container">
              <EmailIcon />
            </Icon>
            <div>
              {address.email}
            </div>
          </div>
        </div>
      </div>
    )}
    {link && (
      <div className="details-card__link">
        <Icon className="details-card__icon-container">
          <LinkIcon />
        </Icon>
        <Link
          href={`http://${link}`}
          target="_blank"
        >
          {link}
        </Link>
      </div>
    )}
    {children && (
      <div className="details-card__outlet">
        {children}
      </div>
    )}
  </div>
);

DetailsCard.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    postalcode: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    phone: PropTypes.string,
  }),
  children: PropTypes.node,
  link: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

DetailsCard.defaultProps = {
  address: {
    city: '',
    country: '',
    email: '',
    name: '',
    phone: '',
    postalcode: '',
    state: '',
    street: '',
  },
  children: null,
  link: '',
  subtitle: '',
  title: '',
};

export default DetailsCard;



// WEBPACK FOOTER //
// ./src/routes/Case/Details/components/DetailsCard/DetailsCard.js